import React from "react"

import PageList from "../pages-list/page-list"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { graphql, useStaticQuery } from "gatsby"
import { Card } from "@material-ui/core"

function Index() {
  const {
    allMdx: {
      nodes: [first],
    },
  } = useStaticQuery(
    graphql`
      query {
        allMdx(sort: { fields: frontmatter___date, order: DESC }, limit: 1) {
          nodes {
            frontmatter {
              date
              title
            }
            body
          }
        }
      }
    `
  )
  return <MDXRenderer title={first.frontmatter.title}>{first.body}</MDXRenderer>
}

export default Index
